import api from '@/api/index.js'

const account_payment_card_creations = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_PAYMENT_CARD_CREATIONS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_PAYMENT_CARD_CREATIONS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_PAYMENT_CARD_CREATIONS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountPaymentCardCreations({commit}, accountID) {
      commit('SET_PAYMENT_CARD_CREATIONS_ERROR', null)
      commit('SET_ACCOUNT_PAYMENT_CARD_CREATIONS_LOADING', true)
      return api.get(`accounts/${accountID}/payment-card-creations?limit=150&offset=0`)
        .then((response) => {
          commit('SET_PAYMENT_CARD_CREATIONS', response)
        })
        .catch((error) => {
          commit('SET_PAYMENT_CARD_CREATIONS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_payment_card_creations
